var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.525 37.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27.525v37.934H0z",
    "data-name": "Ret\\xE2ngulo 238"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Grupo 467"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.979 37.934h23.567a1.982 1.982 0 0 0 1.979-1.98V1.98A1.982 1.982 0 0 0 25.546 0H1.979A1.982 1.982 0 0 0 0 1.979v33.974a1.982 1.982 0 0 0 1.979 1.98ZM1.366 1.98a.615.615 0 0 1 .614-.614h23.566a.615.615 0 0 1 .614.614v33.974a.615.615 0 0 1-.614.615H1.98a.615.615 0 0 1-.614-.615V1.98Z",
    "data-name": "Caminho 453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.011 17.481h7.512a.682.682 0 0 0 .683-.682.7.7 0 0 0-.01-.122 4.434 4.434 0 0 0-8.867.122.682.682 0 0 0 .682.682Zm3.752-3.751a3.074 3.074 0 0 1 2.992 2.386H10.77a3.074 3.074 0 0 1 2.993-2.386Z",
    "data-name": "Caminho 454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.763 11.766a2.257 2.257 0 1 0-2.257-2.257 2.26 2.26 0 0 0 2.257 2.257m0-3.148a.892.892 0 1 1-.891.891.892.892 0 0 1 .891-.891",
    "data-name": "Caminho 455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.763 21.613a8.566 8.566 0 1 0-8.566-8.566 8.575 8.575 0 0 0 8.566 8.566m0-15.767a7.2 7.2 0 1 1-7.2 7.2 7.209 7.209 0 0 1 7.2-7.2",
    "data-name": "Caminho 456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.715 26.658h17.793a.683.683 0 0 0 0-1.365H4.715a.683.683 0 0 0 0 1.365",
    "data-name": "Caminho 457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.715 30.187h17.793a.682.682 0 0 0 0-1.365H4.715a.683.683 0 0 0 0 1.365",
    "data-name": "Caminho 458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.715 33.716H18.53a.682.682 0 0 0 0-1.365H4.715a.683.683 0 0 0 0 1.365Z",
    "data-name": "Caminho 459"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilesIcon);
export default __webpack_public_path__ + "static/media/profiles-icon.a023f587aa669b7a25980d276b3fa9cd.svg";
export { ForwardRef as ReactComponent };